module.exports = __webpack_public_path__ + "static/img/job4.3f58b76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/job4.png
// module id = /qW5
// module chunks = 0